export default __webpack_public_path__ + "static/media/first-step-haus.48b75b2d.svg";